import ProjectConsultantsContainer from './ProjectConsultantsContainer';
export default ProjectConsultantsContainer;